import { sentry_exports } from "./chunk-UYPMFTMU.mjs";
import { slack_exports } from "./chunk-VJLAJZPG.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/constants/index.ts

var constants_exports = {};

__export(constants_exports, {
  DEFAULT_BIRTHDAY_ON_BACKEND: function DEFAULT_BIRTHDAY_ON_BACKEND() {
    return _DEFAULT_BIRTHDAY_ON_BACKEND;
  },
  MAX_SMS_VERIFICATION_CODE_INPUT_LENGTH: function MAX_SMS_VERIFICATION_CODE_INPUT_LENGTH() {
    return _MAX_SMS_VERIFICATION_CODE_INPUT_LENGTH;
  },
  Sentry: function Sentry() {
    return sentry_exports;
  },
  Slack: function Slack() {
    return slack_exports;
  },
  ZHONGAN_PROVIDER_NAME: function ZHONGAN_PROVIDER_NAME() {
    return _ZHONGAN_PROVIDER_NAME;
  }
});

var _MAX_SMS_VERIFICATION_CODE_INPUT_LENGTH = 8;
var _ZHONGAN_PROVIDER_NAME = "zhongan";
var _DEFAULT_BIRTHDAY_ON_BACKEND = "1970-01-01";
export { _MAX_SMS_VERIFICATION_CODE_INPUT_LENGTH as MAX_SMS_VERIFICATION_CODE_INPUT_LENGTH, _ZHONGAN_PROVIDER_NAME as ZHONGAN_PROVIDER_NAME, _DEFAULT_BIRTHDAY_ON_BACKEND as DEFAULT_BIRTHDAY_ON_BACKEND, constants_exports };